export default __webpack_public_path__ + "static/media/chat.6d254d0f.svg";